import { useParams } from '@tanstack/react-router';
import { EmptyState } from '../components/ui.js';
import { useSlot } from '../lib/slots.js';

/** A whole screen from the client's `app.routes` slot, served at `/x/<path>`. */
export function ExtensionRoute() {
  const { _splat: path = '' } = useParams({ strict: false }) as { _splat?: string };
  const routes = useSlot('app.routes');
  const wanted = path.replace(/^\/+|\/+$/g, '');
  const route = routes.find((r) => r.path.replace(/^\/+|\/+$/g, '') === wanted);
  if (!route)
    return (
      <EmptyState title="There is no such screen">
        It may have been removed in an update. Use the menu to find your way.
      </EmptyState>
    );
  const Screen = route.component;
  return <Screen />;
}
